import { Component } from '@angular/core';

import { BaseModalDirective } from '@app/components/modals/base-modal';

@Component({
    templateUrl: './confirm-open-appeal.component.html',
    styleUrls: ['./confirm-open-appeal.component.scss'],
    standalone: false
})
export class ConfirmOpenAppealModalComponent extends BaseModalDirective {
    
    decreaseFont(){
    const globalLang = sessionStorage.getItem('globalTranslatedLan'); 
    return globalLang === 'ru';
  }
}
